export default {"src":"/_next/static/media/database-servers.21dd5091.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};